'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _pageSize;

var _utils = require('../utils');

function _pageSize(list, opts) {
    list = list || {};
    opts = opts || {};

    if (!(0, _utils.isUndefined)(opts.pageSize)) return opts.pageSize;

    if (!(0, _utils.isUndefined)(list.pageSize)) return list.pageSize;

    return 10;
}